import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import LocalizedStrings from 'react-localization';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './ReleaseRefundClientModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class ReleaseRefundClientModal extends Component {
    constructor(props) {
		super(props);
		this.state = { 
            total: 0,
        }
    }

	componentWillReceiveProps(props) {
		let total = 0;
		if (props.refundDetails) {
			props.refundDetails.forEach((refundDetail) => {
				total += refundDetail.price;
			});
		}
		this.setState({
			total,
		});
	}

    render() {
	  	return (
			<div>
		  		<Modal isOpen={this.props.isReleaseRefundClientOpen} toggle={this.toggle}>
		          	<ModalHeader toggle={this.props.toggleReleaseRefundModal}>{strings.title}</ModalHeader>
		          	<ModalBody>
						<p>{strings.confirm1} 
							({new Intl.NumberFormat('en-US', {
								style: 'currency',
								currency: 'USD'
							}).format(this.state.total)})
						{strings.confirm2}</p>
						<p>{strings.patrons}</p>
						<table className="showtix-table showtix-table__striped">
							<thead>
								<tr>
									<th>
										{strings.tickets}
									</th>
									<th>
										{strings.donation}
									</th>
									<th>
										{strings.customFees}
									</th>
									<th>
										{strings.showtixFees}
									</th>
									<th>
										{strings.mailingFees}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td className="is-right">
										√
									</td>
									<td className="is-right">
										√
									</td>
									<td className="is-right">
										√
									</td>
									<td className="is-wrong">
										X
									</td>
									<td className="is-wrong">
										X
									</td>
								</tr>
							</tbody>
						</table>
						<div className="d-flex justify-content-center mt-4">
							<button 
								className="showtix-button showtix-background__grey-1"
								onClick={this.props.toggleReleaseRefundModal}
								>{strings.cancel}</button>
							<button 
								className="showtix-button showtix-background__primary-3"
								onClick={this.props.confirmClientRefund}
								>{strings.confirm}</button>    
		          		</div>
					</ModalBody>
		        </Modal>
			</div>
	  	);
	}
}

ReleaseRefundClientModal.propTypes = {
    isReleaseRefundClientOpen: PropTypes.bool,
    toggleReleaseRefundModal: PropTypes.func,
    confirmAlertModal: PropTypes.func,
}

export default ReleaseRefundClientModal;


// WEBPACK FOOTER //
// ./src/components/Search/ReleaseRefundClientModal/ReleaseRefundClientModal.js